/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Apply_All_A_To_BInputs */



/**
* | output |
* | --- |
* | "Apply All A → B" |
*
* @param {Compare_Event_Groups_Apply_All_A_To_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_apply_all_a_to_b = /** @type {((inputs?: Compare_Event_Groups_Apply_All_A_To_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Apply_All_A_To_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer tout A → B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle anwenden A → B")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica tutto A → B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Примените все A → B")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar todo A → B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("应用所有 A → B")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて適用 A → B")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी A → B लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar tudo de A para B")
	return /** @type {LocalizedString} */ ("Apply All A → B")
});